export const GALLERY_CATEGORY_OPTIONS = [
  { value: 'Community', label: 'समुदाय' },
  { value: 'Infrastructure', label: 'पायाभूत सुविधा' },
  { value: 'Health', label: 'आरोग्य' },
  { value: 'Education', label: 'शिक्षण' },
  { value: 'Environment', label: 'पर्यावरण' },
  { value: 'Agriculture', label: 'शेती' },
  { value: 'Events', label: 'कार्यक्रम' },
  { value: 'Other', label: 'इतर' },
];

export const getGalleryCategory = value => (
  GALLERY_CATEGORY_OPTIONS.find(option => option.value === value)
  || GALLERY_CATEGORY_OPTIONS[GALLERY_CATEGORY_OPTIONS.length - 1]
);

export const getYouTubeVideoId = value => {
  try {
    const url = new URL(String(value || ''));
    if (url.hostname === 'youtu.be') return url.pathname.split('/').filter(Boolean)[0] || '';
    if (url.hostname.endsWith('youtube.com')) {
      if (url.pathname === '/watch') return url.searchParams.get('v') || '';
      const parts = url.pathname.split('/').filter(Boolean);
      if (['embed', 'shorts'].includes(parts[0])) return parts[1] || '';
    }
  } catch {
    return '';
  }
  return '';
};

export const getGalleryPreviewUrl = item => {
  if (item?.thumbnail_url) return item.thumbnail_url;
  if (item?.media_type !== 'video') return item?.image_url || '';
  const youtubeId = getYouTubeVideoId(item?.image_url);
  return youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg` : '';
};

export const getGalleryVideoEmbedUrl = item => {
  const youtubeId = getYouTubeVideoId(item?.image_url);
  return youtubeId ? `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0` : '';
};

export const normalizeGalleryItem = item => ({
  ...item,
  title: String(item?.title || 'गॅलरी मीडिया').trim(),
  caption: String(item?.caption || item?.description || '').trim(),
  category: getGalleryCategory(item?.category).value,
  media_type: item?.media_type === 'video' ? 'video' : 'image',
  event_date: item?.event_date || item?.date || item?.created_at || item?.createdAt || '',
  sort_order: Number(item?.sort_order || 0),
  is_featured: item?.is_featured === true,
  is_published: item?.is_published !== false,
});

const timeOf = item => {
  const time = new Date(item.event_date || 0).getTime();
  return Number.isFinite(time) ? time : 0;
};

export const sortGalleryItems = (items, order = 'curated') => [...items].sort((left, right) => {
  if (left.is_featured !== right.is_featured) return left.is_featured ? -1 : 1;
  if (order === 'newest') return timeOf(right) - timeOf(left) || left.sort_order - right.sort_order;
  if (order === 'oldest') return timeOf(left) - timeOf(right) || left.sort_order - right.sort_order;
  if (order === 'title') return left.title.localeCompare(right.title, 'mr');
  return left.sort_order - right.sort_order || timeOf(right) - timeOf(left);
});

export const groupGalleryItems = items => GALLERY_CATEGORY_OPTIONS
  .map(category => ({
    ...category,
    items: items.filter(item => item.category === category.value),
  }))
  .filter(group => group.items.length > 0);
